import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from '@this/shared/header/header';
import Footer from '@this/shared/footer/footer';
import { createTheme } from '@this/constants/themes';
import { AITThemeProvider } from '@this/shared/ui/theme';

type PageBadRequestProps = {
  heading?: string;
  messages?: string[];
  linkLabel?: string;
  linkHref?: string;
};

const defaultMessages = ['ログイン状態とアクセス先をご確認のうえ、再度お試しください。'];

export const PageBadRequest = ({
  heading = '不正なリクエストです。',
  messages = defaultMessages,
  linkLabel = 'トップページに戻る',
  linkHref = '/'
}: PageBadRequestProps) => {
  const theme = createTheme();

  return (
    <AITThemeProvider theme={theme}>
      <Router>
        <div style={wrapperStyle}>
          <Header />
          <div style={contentStyle}>
            <h1 style={titleStyle}>400 Bad Request</h1>
            <section style={sectionStyle}>
              <p>{heading}</p>
            </section>
            <section style={sectionStyle}>
              {messages.map(message => (
                <p key={message}>{message}</p>
              ))}
            </section>
            <section style={sectionStyle}>
              <a href={linkHref}>{linkLabel}</a>
            </section>
          </div>
          <Footer signedIn={false} />
        </div>
      </Router>
    </AITThemeProvider>
  );
};

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh'
};

const contentStyle: React.CSSProperties = {
  minHeight: 'calc(100vh - 50px - 74px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

const titleStyle: React.CSSProperties = {
  margin: '100px 0 20px',
  fontSize: '1.5em'
};

const sectionStyle: React.CSSProperties = {
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};
